import { GetToken } from '../services/api';

/**
 * URL de anexo servido pelo backend (GET /api/v2/uploads/...).
 *
 * A rota exige autenticação e navegação de <a>/<img> não envia o header
 * Authorization — o backend aceita `?access_token=` justamente para esses
 * casos. Aqui normalizamos a base (REACT_APP_API_URL pode vir com ou sem
 * /api/v2) e anexamos o token. Extraído do OutboundDetailsPage para reuso.
 */

const RAW_API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:9999';

export function ResolveUploadsBaseUrl(rawBaseUrl = RAW_API_BASE_URL) {
    const sanitized = String(rawBaseUrl || '')
        .trim()
        .replace(/\/+$/, '');

    if (!sanitized) {
        return 'http://localhost:9999/api/v2';
    }

    // Base relativa (mesma origem, via proxy) — ver services/api.js.
    if (sanitized.startsWith('/')) {
        return sanitized.endsWith('/api/v2') ? sanitized : '/api/v2';
    }

    if (sanitized.endsWith('/api/v2')) {
        return sanitized;
    }

    if (sanitized.endsWith('/api')) {
        return `${sanitized}/v2`;
    }

    return `${sanitized}/api/v2`;
}

export function ResolveAssetUrl(assetPath) {
    if (!assetPath) {
        return null;
    }

    const token = GetToken();
    const base = ResolveUploadsBaseUrl(RAW_API_BASE_URL);
    const rawAsset = String(assetPath).trim();
    let candidatePath = rawAsset;

    if (/^https?:\/\//i.test(rawAsset)) {
        try {
            const parsed = new URL(rawAsset);
            candidatePath = `${parsed.pathname}${parsed.search || ''}`;
        } catch {
            candidatePath = rawAsset;
        }
    }

    const [rawPath, rawQuery = ''] = String(candidatePath).split('?');
    const withLeadingSlash = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
    const normalizedPath = withLeadingSlash
        .replace(/^\/api\/v2\/uploads(?=\/|$)/i, '/uploads')
        .replace(/^\/api\/uploads(?=\/|$)/i, '/uploads');
    const resolvedPath = normalizedPath.startsWith('/uploads/') ? normalizedPath : `/uploads${normalizedPath}`;
    const queryParams = new URLSearchParams(rawQuery);
    if (token && !queryParams.has('access_token')) {
        queryParams.set('access_token', token);
    }
    const queryString = queryParams.toString();
    return `${base}${resolvedPath}${queryString ? `?${queryString}` : ''}`;
}
